import SecurityBlock from '@Web/Pages/Web/Pricing/Components/SecurityBlock';
import PricingTable from '@Web/Pages/Web/Pricing/Components/PricingTable';
import PlanCards from '@Web/Pages/Web/Pricing/Components/PlanCards';
import { PRICING_FAQ } from '@Web/Pages/Web/Pricing/constants.js';
import GetDemo from '@Web/Pages/Web/Pricing/Components/GetDemo';
import SectionHeader from '@Web/Src/Components/SectionHeader';
import PricingSection from '@Web/Src/UI/Pricing';
import Businesses from '@Web/Src/UI/Businesses';
import DemoInput from '@Web/Src/UI/DemoInput';
import Layout from '@Web/Pages/Web/Layout';
import Faq from '@Web/Src/UI/Faq';

function Pricing() {
    return (
        <Layout>
            <div className='page-container relative flex flex-col items-center justify-center'>
                <SectionHeader
                    type='dark'
                    className='mx-auto mt-8'
                    icon='credit-card'
                    title={__('Flexible pricing plans that scales as you grow')}
                    desc={__(
                        'All plans include deep integrations with many CRMs and Stripe.'
                    )}
                    topTitle={true}
                />
                <PricingSection fromPricingPage={true} />
                <GetDemo />
                <PlanCards className={'mt-40'} />
                <SecurityBlock />
                <PricingTable />
                <Businesses className='mt-44' />
                <DemoInput className={'mt-44'} />
                <Faq className='!mt-44' data={PRICING_FAQ} title={__('FAQ')} />
            </div>
        </Layout>
    );
}

export default Pricing;
